import { Link } from "react-router-dom";
import { FileText, UserPlus, ClipboardList, Package, Stethoscope } from "lucide-react";
import { DashboardCard } from "@/shared/ui/DashboardCard";
import { useTranslation } from "@/shared/providers/LanguageProvider";
import { adminRecentActivity } from "../../data";
import { activityTypeRoutes } from "../../navigation/dashboardRoutes";

const activityIcons = {
  admission: Stethoscope,
  invoice: FileText,
  request: ClipboardList,
  employee: UserPlus,
  package: Package,
};

export function RecentActivityWidget() {
  const { t } = useTranslation();

  return (
    <DashboardCard title={t.safecheck.adminDashboard.recentActivity}>
      <ul className="space-y-3">
        {adminRecentActivity.map((activity) => {
          const Icon = activityIcons[activity.type as keyof typeof activityIcons];
          const message =
            t.safecheck.adminDashboard.activities[activity.type as keyof typeof t.safecheck.adminDashboard.activities];

          return (
            <li key={activity.id}>
              <Link
                to={activityTypeRoutes[activity.type] ?? "/dashboard/admin"}
                className="flex items-center gap-3 rounded-xl border border-border bg-card-muted/30 px-3 py-2.5 transition-colors hover:border-accent/40 hover:bg-card-muted/60"
              >
              <div className="flex h-9 w-9 shrink-0 items-center justify-center rounded-lg bg-primary-soft">
                <Icon size={16} className="text-primary" />
              </div>
              <div className="min-w-0 flex-1">
                <p className="truncate text-sm text-foreground">{message}</p>
                <p className="text-xs text-muted">
                  {activity.time} {t.safecheck.adminDashboard.ago}
                </p>
              </div>
              </Link>
            </li>
          );
        })}
      </ul>
    </DashboardCard>
  );
}
